(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "697981561b208f304a03e213";
              window.beaePageSetting.pageTitle = "UK-FOOT"; 
              window.beaePageSetting.pageType = "footer";

          let js_5QOHRFLQ = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-c0ywq2uosection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-c0ywq2uo',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-c0ywq2uo');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-c0ywq2uo: ', ex)
      };
    

      try {
        let argid = 'beae-2pirlgcfblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2pirlgcf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2pirlgcf');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2pirlgcf: ', ex)
      };
    

      try {
        let argid = 'beae-wwoqwo11section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wwoqwo11',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wwoqwo11');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wwoqwo11: ', ex)
      };
    

      try {
        let argid = 'beae-dlh7oos6section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-dlh7oos6',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-dlh7oos6');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-dlh7oos6: ', ex)
      };
    

      try {
        let argid = 'beae-4h99ios4section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4h99ios4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4h99ios4');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4h99ios4: ', ex)
      };
    

      try {
        let argid = 'beae-mywwpoyasection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-mywwpoya',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-mywwpoya');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-mywwpoya: ', ex)
      };
    

      try {
        let argid = 'beae-o8w4r0smblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-o8w4r0sm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-o8w4r0sm');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-o8w4r0sm: ', ex)
      };
    

      try {
        let argid = 'beae-1tj7nhzklinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1tj7nhzk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1tj7nhzk');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1tj7nhzk: ', ex)
      };
    

      try {
        let argid = 'beae-3ry6vfn4linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-3ry6vfn4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-3ry6vfn4');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-3ry6vfn4: ', ex)
      };
    

      try {
        let argid = 'beae-qhfvmgoqsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qhfvmgoq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qhfvmgoq');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qhfvmgoq: ', ex)
      };
    

      try {
        let argid = 'beae-d23pvfssblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d23pvfss',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d23pvfss');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),z,R=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(I){let A=0,D;j(),R?H.onmouseover=function(W){q(W)}:I.onmousedown=function(W){q(W)},H.onmouseup=function(){Z()},I.ontouchstart=function(W){q(W)},H.ontouchend=function(){Z()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=T.offsetWidth})}).observe(T),I.style.left&&parseInt(I.style.left)}function q(W){check=!1,W.preventDefault(),W.clientX?W.clientX:W.touches[0].clientX,parseInt(I.style.left),A=1,H.onmousemove=function(Y){F(Y)},H.ontouchmove=function(Y){F(Y)}}function Z(){A=0,check=!0}function F(W){if(A==0)return!1;D=U(W),D<0&&(D=0),D>100&&(D=100),G(D)}function U(W){const Y=H.getBoundingClientRect(),oe=(W.changedTouches?W.changedTouches[0].clientX:W.clientX)-Y.left;return Math.max(0,Math.min(100,Math.round(oe*100/z)))}function G(W){I.style.left=W+"%",T.style.clipPath=`polygon(${W}% 0%, ${W}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${W}% 0%, ${W}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let z=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(z)return z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d23pvfss: ', ex)
      };
    

      try {
        let argid = 'beae-xggy7bp7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xggy7bp7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xggy7bp7');
        args.el = args.els[0];
        ((P) => { var z;let H=(z=P.el)==null?void 0:z.querySelectorAll(".beae-x-text a");H==null||H.forEach(R=>{let O=R==null?void 0:R.getAttribute("href");R&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&R.addEventListener("click",I=>{let A=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(A)return A.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),I.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xggy7bp7: ', ex)
      };
    

      try {
        let argid = 'beae-rbzppzxplinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-rbzppzxp',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-rbzppzxp');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-rbzppzxp: ', ex)
      };
    

      try {
        let argid = 'beae-l8p73cnilinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-l8p73cni',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-l8p73cni');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-l8p73cni: ', ex)
      };
    

      try {
        let argid = 'beae-6czpi8w9section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6czpi8w9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6czpi8w9');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6czpi8w9: ', ex)
      };
    

      try {
        let argid = 'beae-2hmnzuylblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2hmnzuyl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2hmnzuyl');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),z,R=window.innerWidth>=768&&M.autoHover;var V=H.querySelector(".beae-img-ratio-control"),L=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(V&&T){let O=function(I){let A=0,D;j(),R?H.onmouseover=function(W){q(W)}:I.onmousedown=function(W){q(W)},H.onmouseup=function(){Z()},I.ontouchstart=function(W){q(W)},H.ontouchend=function(){Z()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=T.offsetWidth})}).observe(T),I.style.left&&parseInt(I.style.left)}function q(W){check=!1,W.preventDefault(),W.clientX?W.clientX:W.touches[0].clientX,parseInt(I.style.left),A=1,H.onmousemove=function(Y){F(Y)},H.ontouchmove=function(Y){F(Y)}}function Z(){A=0,check=!0}function F(W){if(A==0)return!1;D=U(W),D<0&&(D=0),D>100&&(D=100),G(D)}function U(W){const Y=H.getBoundingClientRect(),oe=(W.changedTouches?W.changedTouches[0].clientX:W.clientX)-Y.left;return Math.max(0,Math.min(100,Math.round(oe*100/z)))}function G(W){I.style.left=W+"%",T.style.clipPath=`polygon(${W}% 0%, ${W}% 100%, 100% 100%, 100% 0)`,L.style.clipPath=`polygon(0% 100%, 0% 0%, ${W}% 0%, ${W}% 100%)`}};V&&T&&O(V),window.addEventListener("resize",function(){V&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=T.offsetWidth})}).observe(T),O(V))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let z=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(z)return z.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2hmnzuyl: ', ex)
      };
    

      try {
        let argid = 'beae-drbnbkl0section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-drbnbkl0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-drbnbkl0');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-drbnbkl0: ', ex)
      };
    

      try {
        let argid = 'beae-y538i4nalc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-y538i4na',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-y538i4na');
        args.el = args.els[0];
        ((g) => { let h=g.checkLive;function u(x){return{input:x.querySelector('input[name="locale_code"], input[name="country_code"]'),button:x.querySelector("button.beae-current-value"),panel:x.querySelector(".beae-language-results"),search:x.querySelector('input[name="language_filter"]'),resetButton:x.querySelector(".beae-reset-button")}}function f(x,M){const V=g.el.querySelector("form.beae-localization");M.input.value=x.currentTarget.dataset.value,V&&V.submit()}function b(x){x.button.focus(),x.panel.classList.toggle("hidden-dropdown"),x.button.setAttribute("aria-expanded",(x.button.getAttribute("aria-expanded")==="false").toString());const M=x.button.getBoundingClientRect();window.innerHeight-M.bottom<x.panel.offsetHeight?(x.panel.style.top="auto",x.panel.style.bottom="100%"):(x.panel.style.top="100%",x.panel.style.bottom="auto")}function C(x){return x.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function m(x,M){const V=C(M.search.value),L=x.querySelectorAll(".beae-languages li");L.length,M.resetButton.classList.toggle("hidden",!V),L.forEach(T=>{C(T.querySelector(".beae-language-name").textContent).indexOf(V)>-1?T.classList.remove("beae-hidden"):T.classList.add("beae-hidden")})}function _(x){x.code.toUpperCase()==="ENTER"&&x.preventDefault()}function S(x,M,V){x.stopPropagation(),V.search.value="",m(M,V)}function B(x,M,V){(!M.contains(x.target)||!M.contains(x.relatedTarget))&&(k(M,V),V.button.setAttribute("aria-expanded",(V.button.getAttribute("aria-expanded")==="false").toString()))}function k(x,M){M.panel.classList.add("hidden-dropdown"),M.search&&(M.search.value="",m(x,M))}function $(x){const M=u(x);h&&x.addEventListener("focusout",V=>B(V,x,M)),M.button.addEventListener("click",()=>b(M)),x.querySelectorAll(".beae-language-name").forEach(V=>V.addEventListener("click",L=>f(L,M))),M.search&&(M.search.addEventListener("keyup",()=>m(x,M)),M.search.addEventListener("keydown",_)),M.resetButton&&(M.resetButton.addEventListener("click",V=>S(V,x,M)),M.resetButton.addEventListener("mousedown",V=>V.preventDefault()))}g.el.querySelectorAll(".beae-localization").forEach($) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-y538i4na: ', ex)
      };
    

      try {
        let argid = 'beae-ezth3qixlc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ezth3qix',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ezth3qix');
        args.el = args.els[0];
        ((y) => { let g=y.checkLive;function h(w){return{input:w.querySelector('input[name="locale_code"], input[name="country_code"]'),button:w.querySelector("button.beae-current-value"),panel:w.querySelector(".beae-country-results"),search:w.querySelector('input[name="country_filter"]'),resetButton:w.querySelector(".beae-reset-button")}}function u(w,x){const M=y.el.querySelector("form.beae-localization");x.input.value=w.currentTarget.dataset.value,M&&M.submit()}function f(w){w.button.focus(),w.panel.classList.toggle("hidden-dropdown"),w.button.setAttribute("aria-expanded",(w.button.getAttribute("aria-expanded")==="false").toString());const x=w.button.getBoundingClientRect();window.innerHeight-x.bottom<w.panel.offsetHeight?(w.panel.style.top="auto",w.panel.style.bottom="100%"):(w.panel.style.top="100%",w.panel.style.bottom="auto")}function b(w){return w.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function C(w,x){const M=b(x.search.value),V=w.querySelectorAll(".beae-countries li");V.length,x.resetButton.classList.toggle("hidden",!M),V.forEach(L=>{b(L.querySelector(".beae-country-name").textContent).indexOf(M)>-1?L.classList.remove("beae-hidden"):L.classList.add("beae-hidden")})}function m(w){w.code.toUpperCase()==="ENTER"&&w.preventDefault()}function _(w,x,M){w.stopPropagation(),M.search.value="",C(x,M)}function S(w,x,M){(!x.contains(w.target)||!x.contains(w.relatedTarget))&&(B(x,M),M.button.setAttribute("aria-expanded",(M.button.getAttribute("aria-expanded")==="false").toString()))}function B(w,x){x.panel.classList.add("hidden-dropdown"),x.search&&(x.search.value="",C(w,x))}function k(w){const x=h(w);g&&w.addEventListener("focusout",M=>S(M,w,x)),x.button.addEventListener("click",()=>f(x)),w.querySelectorAll(".beae-country-name").forEach(M=>M.addEventListener("click",V=>u(V,x))),x.search&&(x.search.addEventListener("keyup",()=>C(w,x)),x.search.addEventListener("keydown",m)),x.resetButton&&(x.resetButton.addEventListener("click",M=>_(M,w,x)),x.resetButton.addEventListener("mousedown",M=>M.preventDefault()))}y.el.querySelectorAll(".beae-localization").forEach(k) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ezth3qix: ', ex)
      };
    }; if (window.BEAEBASE) {js_5QOHRFLQ()} else {window.BEAEPAGEJS.push(js_5QOHRFLQ)} })(); 